import React from 'react';
import { compose, graphql } from 'react-apollo';
import { ToastContainer } from 'react-toastr';
import Banner from '../../../../components/Banner/index';
import Footer from '../../../../components/Footer/index';
import CREATE_PRODUCTION_MUTATION from '../../../../graphql/CreateProduction';
import Form from '../Form';
import CAN_CREATE_QUERY from '../../../../graphql/CanCreateMoreProductions';
import { IsAdmin, IsTheaterAdmin } from '../../../../utils/Roles';

class CreateProduction extends React.Component {
  componentWillMount() {
    if (!IsAdmin() && !IsTheaterAdmin()) {
      this.props.history.push('/login');
    }
  }

  componentDidUpdate(prevProps) {
    const { canCreate } = this.props;
    if (prevProps.canCreate === undefined && canCreate === false) {
      this.toastr.warning('Recuerda que para crear más producciones debes actualizar tu plan');
    }
  }

  getTitle = () => {
    if (this.props.isDigital) { return 'Nueva Producción Digital'; }
    return 'Nueva Producción';
  };

  handleProductionCreation = (theater) => {
    const { mutate, history } = this.props;

    mutate({
      variables: theater,
    })
      .then(() => {
        this.toastr.success('Producción creada correctamente');
        setTimeout(() => {
          history.push('/admin/productions');
        }, 3000);
      })
      .catch((err) => {
        if ({}.hasOwnProperty.call(err, 'graphQLErrors')) {
          err.graphQLErrors.forEach((v) => {
            this.toastr.error('Ocurrió un error guardando la producción');
          });
        }
      });
  };

  render() {
    return (
      <div>
        <ToastContainer
          ref={(ref) => { this.toastr = ref; }}
          className="toast-top-right"
        />

        <Banner />
        <div className="properties-details-page">
          <div className="container">
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10 new-form-container">
                {this.props.canCreate === false && (
                  <div className="alert alert-warning" role="alert">Recuerda que para crear más producciones debes actualizar tu plan</div>
                )}
                <div className="submit-address">
                  <Form
                    title={this.getTitle()}
                    isDigital={this.props.isDigital}
                    onSubmit={this.handleProductionCreation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withMutation = graphql(CREATE_PRODUCTION_MUTATION);
const canCreate = graphql(CAN_CREATE_QUERY, {
  props: ({ data }) => ({
    canCreate: data.canCreateMoreProductions,
  }),
});

export default compose(withMutation, canCreate)(CreateProduction);



// WEBPACK FOOTER //
// ./src/containers/Admin/Production/Create/index.js